export const Logo = ({ className = "h-7 w-7" }) => (
    <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
        <path
            d="M7.5 24.5 C 15.5 24.5, 13.5 7.5, 24.5 7.5"
            stroke="#C85A32"
            strokeWidth="2.6"
            strokeLinecap="round"
        />
        <circle cx="7.5" cy="24.5" r="3" fill="#3A5A40" />
        <circle cx="24.5" cy="7.5" r="3" fill="#C85A32" />
    </svg>
);

export default Logo;
